import { useEffect, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { FiSearch } from 'react-icons/fi';
import { Flex, Image, useToast } from '@chakra-ui/react';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import Loading from '../../components/Loading';
import Sidebar from '../../components/Sidebar';
import InputDate from '../../components/Inputs/InputDate';
import DataTableFichas from '../../components/ComponentsFichas/DataTableFichas';
import ImgLoading from '../../assets/loading/tres_pontos.gif';

import { Container, Content, Filtros, FormView } from './styles';


type FichaData = {
	banca: string;
	cliente: string;
	cod_emp: number;
	cod_ficha: number;
	cod_ped: string;
	cod_pro: number;
	cod_event: number;
	dat_cad: string;
	descricao: string;
	imagem: string;
	nome_pro: string;
	proxima_op: string;
	quant_atual: number;
	quant_incial: number;
	status_des: string;
	usuario: string;
	apontamento: boolean;
}
const Fichas: React.FC = () => {
	const formRef = useRef<FormHandles>(null);
	const { company } = useAuth();
	const toast = useToast();

	const [loading, setLoading] = useState(true);
	const [loadData, setLoadData] = useState(true);

	const [radioStatus, setRadioStatus] = useState('A');
	const [fichas, setFichas] = useState<FichaData[]>([]);

	const [modalApontaScroll, setModalApontaScroll] = useState(false);

	async function handleGetFichas(data: any) {
		setLoadData(true);
		await api.post('/portal/fichas', data)
			.then(response => {
				setFichas(response.data);
			})
			.catch(err => {
				setFichas([]);
				toast({
					title: 'Fichas.',
					description: 'Essa empresa talvez não tenha nenhuma ficha!',
					status: 'error',
					duration: 5000,
					position: 'top-right',
					isClosable: true,
					containerStyle: {
						marginTop: '20'
					}
				})
			})
			.finally(() => setLoadData(false))
	};

	useEffect(() => {
		setLoading(false);
		handleGetFichas({ status: radioStatus, data_i: "", data_f: ''});
	}, [company]);

	// UseEffect para bloquear a rolagem ao abrir algum modal
	useEffect(() => {
		if (modalApontaScroll) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'auto';
		}
	}, [modalApontaScroll]);

	async function handleForm(data: any) {
		const dados = { 
			status: radioStatus,
			data_i: data.data_i,
			data_f: data.data_f
		};

		await handleGetFichas(dados);
	};

	return (
		<>
			<Container>
				<Sidebar />

				{loading ? (
					<Loading />
				) : (
					<Content>
						<Filtros>
							<FormView ref={formRef} onSubmit={handleForm}>
								<Flex width="100%" justify="center" mr={[0, 0, 2, 2]}>
									<Flex w="100%" mr={1} flexDirection={["row", "column"]} justify="flex-end">
										<div className="input-content">
											<span>Data Inicial</span>
											<InputDate
												name="data_i"
												placeholder="Data Inicial"
												containerStyle={{ padding: '5px 7px' }}
											/>
										</div>
									</Flex>

									<Flex w="100%" ml={1} flexDirection={["row", "column"]} justify="flex-end">
										<div className="input-content">
											<span>Data Final</span>
											<InputDate
												name="data_f"
												placeholder="Data Final"
												containerStyle={{ padding: '5px 7px' }}
											/>
										</div>
									</Flex>
								</Flex>

								<Flex width="100%" mt={["10px","10px", "0px"]}>
									<Flex width="100%">
										<div className="radio-group">
											<div className="radio-label" onClick={() => setRadioStatus('A')}>
												<input
													type="radio"
													value="A"
													checked={radioStatus === 'A'}
													onChange={() => setRadioStatus('A')}
												/>
												<label>Abertas</label>
											</div>
											
											<div className="radio-label" onClick={() => setRadioStatus('F')}>
												<input
													type="radio"
													value="F"
													checked={radioStatus === 'F'}
													onChange={() => setRadioStatus('F')}
												/>
												<label>Finalizadas</label>
											</div>

											<div className="radio-label" onClick={() => setRadioStatus('T')}>
												<input
													type="radio"
													value="T"
													checked={radioStatus === 'T'}
													onChange={() => setRadioStatus('T')}
												/>
												<label>Todas</label>
											</div>
										</div>
									</Flex>
									
									<Flex flexDirection="column" justify="flex-end">
										<button type="submit">
											<FiSearch /> <span>Pesquisar</span>
										</button>
									</Flex>
								</Flex>
							</FormView>
						</Filtros>

						{loadData ? (
							<Flex w="100%" justify="center" align="center">
								<Image src={ImgLoading} w="100px" h="100px" />
							</Flex>
						) : 
						(fichas.length === 0 ? (
								<Flex>
									<h1>Nenhuma Ficha.</h1>
								</Flex>
							) : (
								<DataTableFichas
									data={fichas}
									setModalApontaScroll={setModalApontaScroll}
									handleGetFichas={handleGetFichas}
									dataGetFichas={{
										status: radioStatus,
										data_i: formRef.current?.getFieldValue('data_i'),
										data_f: formRef.current?.getFieldValue('data_f')
									}}
								/>
							)
								
						)}
					</Content>
				)}
			</Container>
		</>
	)
}

export default Fichas;